import { Action } from 'redux';
import { Page } from '../../../api/api.types';
import { ReservationFilters, ReservationModel } from '../../../api/reservation/reservation.types';

export const GET_RESERVATION_LIST = 'GET_RESERVATION_LIST';
export const GET_RESERVATION = 'GET_RESERVATION';
export const UPDATE_RESRVATION_FILTERS = 'UPDATE_RESRVATION_FILTERS';
export const PATCH_RESERVATION = 'PATCH_RESERVATION';

export interface ReservationState {
  reservations: ReservationModel[] | [];
  selectedReservation: ReservationModel | null;
  postSuccess: boolean | null;
  lastFetch: number | null;
  totalElements: number;
  totalPages: number;
  filters: ReservationFilters | null;
}

export interface GetReservationListAction extends Action {
  type: typeof GET_RESERVATION_LIST;
  payload: {
    page: Page<ReservationModel>;
  };
}

export interface GetReservationAction extends Action {
  type: typeof GET_RESERVATION;
  payload: {
    selectedReservation: ReservationModel | null;
  };
}

export interface UpdateResrvationFiltersAction extends Action {
  type: typeof UPDATE_RESRVATION_FILTERS;
  payload: {
    filters: ReservationFilters | null;
  };
}

export interface PatchResrvationAction extends Action {
  type: typeof PATCH_RESERVATION;
  payload: {
    selectedReservation: ReservationModel;
  };
}

export type ReservationActionTypes = GetReservationListAction | GetReservationAction | UpdateResrvationFiltersAction | PatchResrvationAction;
